/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { observer } from "mobx-react-lite"
import type React from "react"
import type { JSX } from "react"

import { useAppState } from "../../app/app-hooks"

import { ContentSpinner } from "./spinner"

export const withLoading = (Component: React.FC): JSX.Element => {
    const WithLoadingComponent = observer(() => {
        const { isRouteLoading } = useAppState()
        return isRouteLoading ? <ContentSpinner /> : <Component />
    })
    WithLoadingComponent.displayName = `withLoadingWrapper(${Component.displayName || Component.name || "Component"})`
    return <WithLoadingComponent />
}
